/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Reingest_Approval_TitleInputs */

const es_components_reingest_approval_title = /** @type {(inputs: Components_Reingest_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar re-ingesta`)
};

const en_components_reingest_approval_title = /** @type {(inputs: Components_Reingest_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm re-ingestion`)
};

/**
* | output |
* | --- |
* | "Confirm re-ingestion" |
*
* @param {Components_Reingest_Approval_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_reingest_approval_title = /** @type {((inputs?: Components_Reingest_Approval_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Reingest_Approval_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_reingest_approval_title(inputs)
	return en_components_reingest_approval_title(inputs)
});
export { components_reingest_approval_title as "components.reingest_approval.title" }